import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getLanguagePack } from './i18n';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(getLanguagePack().app.rootMissing);
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
